import { render } from "./branding.vue?vue&type=template&id=5efe6bd6&scoped=true&lang=pug"
import script from "./branding.vue?vue&type=script&lang=js"
export * from "./branding.vue?vue&type=script&lang=js"

import "./branding.vue?vue&type=style&index=0&id=5efe6bd6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efe6bd6"]])

export default __exports__